/**
 * Whether a stored-document URL points at a PDF, which decides whether its viewer frame may be
 * sandboxed.
 *
 * Chrome and Edge render NOTHING inside a fully sandboxed iframe when the resource is a PDF
 * (Chromium 41131921, 40328564) -- the owner gets a grey broken-document box and is asked to
 * accept it. It is the same bug that forced DocumentController to scope its
 * `Content-Security-Policy: sandbox` header to HTML only.
 *
 * The extension is only a hint and never the sole defence: this app shares an origin with
 * /api/documents, so an uploaded HTML document would be active script against an authenticated
 * dashboard session -- which is why HTML stays sandboxed here AND is sandboxed server-side by the
 * document route, where a crafted URL cannot reach it.
 */
export function isPdfDocumentUrl(url) {
  return typeof url === 'string' && /\.pdf(?:[?#]|$)/i.test(url);
}
